import {
  plantillaExcelENUM,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
  useUploadFile,
} from "@/shared";
import { useFetchProductoSimple } from "@/shared/actions/erp/producto.action";
import { GeneralTable, LoaderComponent, SingleTableBoxScene } from "@/shared/components/ui";
import { IDataProducto } from "@/shared/interfaces/erp/administration/producto.interface";
import { getEnvs } from "@/shared/utils";
import { Grid } from "@mui/material";
import { MRT_RowData } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { useTableColumnsInventariable } from "./hook/useTableColumnsInventariable";
import { PermissionsEnum } from "@/auth/interfaces";
const { VITE_BUCKET_BASE } = getEnvs();

export default function ProductoPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_producto,
    PermissionsEnum.api_add_producto,
    PermissionsEnum.api_change_producto,
  ])

  const navigate = useNavigate();
  const { columns } = useTableColumnsInventariable();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { fileInputRef, handleImportarInventariable, isPendingInventableExcel } = useUploadFile();

  const { pagination, searchTerm, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: productoRes,
    isRefetching,
  } = useFetchProductoSimple({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      codigo: searchTerm,
      ...filterObject,
      filterByState: false,
    }
  });

  const onEdit = (e: MRT_RowData) => {
    navigate(ROUTER_PATHS.inventario.productosEditarNav + e.id_producto);
  };

  if (isPendingInventableExcel)
    return <LoaderComponent />

  return (
    <SingleTableBoxScene
      title="Productos"
      visibleReport={false}
      urlRedirect={ROUTER_PATHS.inventario.productosCrearNav}
      enableRedirect={true}
      enableUploadFile={true}
      fileInputRef={fileInputRef}
      handleFileUpload={handleImportarInventariable}
      urlDownloadPlantilla={
        //'/test/excel/plantilla_inventariable.xlsx'
        "/" + VITE_BUCKET_BASE + plantillaExcelENUM.PLANTILLA_INVENTARIABLE
      }
      urlDownloadNameExcel="plantilla_inventariable"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<IDataProducto>
            columns={columns}
            data={productoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={productoRes?.data?.count}
            // // actions
            actionsColumnSize={120}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // crud
            onEdit={onEdit}
            canDelete={false}
            positionActionsColumn="first"
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
}
